import React, { createContext } from "react";
import { WPRListDto } from "~/api/GeneratedApi";

type WPRContextType = {
  base64Url: string;
  setBase64Url: React.Dispatch<React.SetStateAction<string>>;
  stepLoadingText: string;
  setStepLoadingText: React.Dispatch<React.SetStateAction<string>>;
  selectedExcelBase: WPRListDto | undefined;
  setSelectedExcelBase: React.Dispatch<
    React.SetStateAction<WPRListDto | undefined>
  >;
};

export const WPRContext = createContext<WPRContextType>({
  base64Url: "",
  setBase64Url: () => "",
  stepLoadingText: "",
  setStepLoadingText: () => false,
  selectedExcelBase: undefined,
  setSelectedExcelBase: () => undefined,
});

type Props = {
  children: React.ReactNode;
};
export const WPRProvider = ({ children }: Props) => {
  const [base64Url, setBase64Url] = React.useState<string>("");
  const [stepLoadingText, setStepLoadingText] = React.useState<string>("");
  const [selectedExcelBase, setSelectedExcelBase] = React.useState<
    WPRListDto | undefined
  >();

  const value: WPRContextType = React.useMemo(
    () => ({
      base64Url,
      setBase64Url,
      stepLoadingText,
      setStepLoadingText,
      selectedExcelBase,
      setSelectedExcelBase,
    }),
    [base64Url, selectedExcelBase, stepLoadingText],
  );

  return <WPRContext.Provider value={value}>{children}</WPRContext.Provider>;
};
